"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Known WebSocket response types.
 * @public
 */
var WebsocketResponseType;
(function (WebsocketResponseType) {
    WebsocketResponseType["Started"] = "started";
    WebsocketResponseType["Stopped"] = "stopped";
    WebsocketResponseType["SegmentEnd"] = "segment_end";
    WebsocketResponseType["Transcript"] = "transcript";
    WebsocketResponseType["Entity"] = "entity";
    WebsocketResponseType["Intent"] = "intent";
    WebsocketResponseType["TentativeTranscript"] = "tentative_transcript";
    WebsocketResponseType["TentativeEntities"] = "tentative_entities";
    WebsocketResponseType["TentativeIntent"] = "tentative_intent";
})(WebsocketResponseType = exports.WebsocketResponseType || (exports.WebsocketResponseType = {}));
//# sourceMappingURL=types.js.map